import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MustMatch } from './mustMatch';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../shared/services/authentication/auth.service';
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';
import { AccountRegister } from 'src/app/models/admModel/account.model';

@Component({
  selector: 'adm-add-publisher-component',
  templateUrl: './add-publisher-component.html',
  styleUrls: ['./add-publisher-component.scss']
})


export class addpublisherComponent implements OnInit {
  public passwordForm: FormGroup;
  public profileForm: FormGroup;
  errorMessage = '';
  countryData: any;
  flag: any;
  accountRegister = new AccountRegister();

  constructor(private fb: FormBuilder,
      private fbpro: FormBuilder,
      private router: Router,
      private toastrService: ToastrService,
      private authService: AuthService,
      private sharedServices: SharedService) {

  }

  ngOnInit() {
    this.getCountries();
    this.createPasswordForm();
    this.createProfileForm();
  }

  getCountries(): void {
    this.sharedServices.getAllCountries()
    .subscribe(
     data => {
       this.countryData = data.data.countries;
       console.log(data);
     },
     error => {
       console.log(error);
     });
  }

  createPasswordForm() {
    this.passwordForm = this.fb.group({
      passwordNew: [null, [Validators.required, Validators.minLength(8)]],
      confirmPassword: [null, Validators.required],
    }, {
      validator: MustMatch('passwordNew', 'confirmPassword')
    });
  }

  createProfileForm(){
    this.profileForm = this.fbpro.group({
      company: [{value: '', disabled: true}],
      checkAdmin: [{value: false, disabled: true}],
      checkPublisher: [{value: true, disabled: true}],
      tax: [{value: '', disabled: true}],
      userName: ['', Validators.required],
      email: ['', Validators.required],
      firstName: ['' , Validators.required],
      lastName: ['', Validators.required],
      street: ['', Validators.required],
      cityName: ['', Validators.required],
      zip: ['', Validators.required],
      country: [null, Validators.required],
      payterm: [{value: 4, disabled: true}],
      rate: [ {value: 0.5, disabled: true}],
      notes: [null]
    });
  }

  onSave() {
    // send API date to backend
    this.accountRegister.username = this.profileForm.value['userName'];
    this.accountRegister.firstName = this.profileForm.value['firstName'];
    this.accountRegister.lastName = this.profileForm.value['lastName'];
    this.accountRegister.email = this.profileForm.value['email'];

    this.accountRegister.password = this.passwordForm.value['passwordNew'];

    this.accountRegister.countryId = this.profileForm.value['country'];
    this.accountRegister.city = this.profileForm.value['cityName'];
    this.accountRegister.zipCode = this.profileForm.value['zip'];
    this.accountRegister.address = this.profileForm.value['street'];
    this.accountRegister.about = this.profileForm.value['notes'];

    this.authService.register(this.accountRegister).subscribe(
      response => {
        this.toastrService.success('New account is registered.', 'Success !');
        this.router.navigate(['/adm/publishers']);
    },
    err => {
        console.log(err);
        this.errorMessage = err.error.errors[0].message;
        this.toastrService.error(`${this.errorMessage}`, 'Error !');
    });

  }

  onCancel(){
    this.router.navigate(['/adm/publishers']);
  }

  setFlag(event){
    this.flag = this.countryData[this.profileForm.value['country']-1].alpha2Code;
  }

}
